import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18n from './i18n/i18n';

const useQuery = () => new URLSearchParams(useLocation().search);

const LanguageProvider = ({ children }) => {
  const language = useQuery().get("language") || 'en';
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  return children;
};

export default LanguageProvider;
